import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-navy" data-id="element-53" data-mp="c6iqbhenhf1c">
      <div className="mx-auto max-w-xl px-4 py-6 text-center sm:px-6 sm:py-8" data-id="element-54" data-mp="c83ln98sh209">
        <h2 id="cierre" className="font-display text-xl font-extrabold text-white sm:text-[1.7rem]" data-id="element-55" data-mp="83m5dk1n16u8">
          Una última oportunidad
        </h2>
        <p className="mt-1.5 text-[0.82rem] leading-snug text-white/80 sm:text-sm" data-id="element-56" data-mp="h6napiioitwu">
          Puedes seguir guardando videos, diagramas y tutoriales y preguntándote
          qué deberías aprender primero. O puedes comenzar hoy a construir una
          habilidad técnica siguiendo una ruta desde cero.
        </p>
        <p className="mt-1.5 text-[0.82rem] leading-snug text-white/80 sm:text-sm" data-id="element-57" data-mp="14w7vm6ye818r">
          No necesitas saber seguridad electrónica para empezar.{' '}
          <strong className="font-bold text-gold" data-id="element-58" data-mp="2c4oct12z9f8b">Necesitas dar el primer paso.</strong>
        </p>

        <Reveal className="mt-4 rounded-2xl border-2 border-gold bg-navy-soft p-4" data-id="element-59" data-mp="2h3hocnypew5u">
          <p className="font-display text-sm font-extrabold leading-tight text-white sm:text-base" data-id="element-60" data-mp="2h5km5u63ltl4">
            🛡️ {PRODUCT_NAME}
          </p>
          <p className="font-display text-sm font-bold text-electric" data-id="element-61" data-mp="2r2yroyqhgxyn">6 Tomos + 5 Bonos</p>
          <p className="mt-1.5 font-display text-xs font-bold text-white/70" data-id="element-62" data-mp="2v4ak1c0qrxaj">
            Valor de los bonos: <span className="line-through" data-id="element-63" data-mp="301tx48lpe40w">{BONUS_TOTAL}</span>
          </p>
          <p className="font-display text-4xl font-black leading-tight text-gold" data-id="element-64" data-mp="34tlr6t42irvs">
            <span className="align-middle text-lg font-extrabold text-white" data-id="element-65" data-mp="34vohle94un11">Hoy: </span>
            {PRICE}
          </p>

          <CtaButton className="mt-3" tone="dark" note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-66" data-mp="3es1jv0iqu97e">
            🚀 SÍ, QUIERO COMENZAR AHORA
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}